export default function CTAFinal() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700 relative overflow-hidden">
      {/* Elementos decorativos */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-teal-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-teal-800/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        {/* Título */}
        <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white mb-8 leading-tight">
          Aprenda a lidar com crises no Alzheimer com mais segurança e previsibilidade
        </h2>

        {/* Subtítulo */}
        <p className="text-lg sm:text-xl text-teal-50 mb-10 leading-relaxed">
          Conheça o protocolo que ensina a identificar sinais antes da crise e saber exatamente o que fazer em situações difíceis.
        </p>

        {/* Botão grande */}
        <a
          href="https://pay.hotmart.com/U103348916W?checkoutMode=10"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block w-full sm:w-auto bg-white hover:bg-gray-50 text-teal-600 font-bold px-10 py-5 rounded-xl text-lg sm:text-xl transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
        >
          Quero acessar o protocolo
        </a>

        {/* Selos de segurança */}
        <div className="mt-6 flex flex-col items-center gap-3">
          <div className="flex items-center gap-2">
            <i className="ri-lock-fill text-teal-200 text-base"></i>
            <span className="text-teal-100 text-xs font-semibold">Compra 100% segura e criptografada</span>
          </div>
        </div>

        {/* Informações adicionais */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-teal-50">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-2xl"></i>
            <span className="text-sm">Garantia de 07 dias</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-lock-line text-2xl"></i>
            <span className="text-sm">Pagamento seguro</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-sm">Acesso imediato</span>
          </div>
        </div>
      </div>
    </section>
  );
}
